// extracted by mini-css-extract-plugin
export default {"pageContainer":"Home_pageContainer__ZZVDT","centerPanel":"Home_centerPanel__hHeTR","projectsPanel":"Home_projectsPanel__Pblo4"};